<template>
  <div class="mh-100 h-100 px-5 py-3 container">
    <div class="h-100" v-if="validateloaded === false">
      <div class="gallery-1 justify-content-center pb-20 h-100 ">
        <div class="placeholder">
          <div class="animated-background"></div>
        </div>
      </div>
    </div>
    <div v-if="validateloaded === true" class="bg-white card mb-2" style="min-height: 90px">
      <div
          class="card-body d-flex justify-content-evenly"
          style="gap: 1.25rem; justify-content: left"
      >
        <div class="d-flex gap-100 w-100 flex-column">
          <div
              v-for="(result, key) in results"
              class="d-inline-flex align-items-center justify-content-evenly bg-white w-100"
              :class="{ 'border-top': key !== 0 }"
          >
            <i
                class="toast-icon"
                :class="{
                            'far fa-exclamation-circle text-danger': !isValidationSuccessful(result),
                            'far fa-check-circle text-success': isValidationSuccessful(result),
                        }"
            ></i>
            <div class="w-75 text-normal">
              <p class="my-3" v-html="getMainText(result)"></p>
              <div v-if="result?.errors">
                <ul class="pl-2">
                  <li class="font-size-100" v-for="error in cleanupErrors(result)">
                    {{ error.rule }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import ViewJson from "../../Viewer/Json/ViewJson.vue";
import MetaDataTable from "../../Viewer/Compare/MetaDataTable.vue";
import VideoQualityFactorTable from "../../../../resultdisplay/VideoQualityFactorTable.vue";
import {EventBus} from "../../../events/event.bus";
import {EVENT_JOB_COMPLETE} from "../../../events/job.events";
import axios from 'axios';
import {testIsTrueish, testIsUndefined} from "../../../../../../../../lib/test-and-assert/test-base";
import {translate} from "../../../../../../../helper/translate";
import JobManager from "../../../manager/JobManager";

export default {
  name: "OutputCompareVideo",
  props: {},
  components: {VideoQualityFactorTable, MetaDataTable, ViewJson},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      results: [],
      errors: null,
      profile: null,
      validateloaded: false
    };
  },
  mounted: function () {
  },
  created: function () {
    EventBus.$on(EVENT_JOB_COMPLETE, (data) => {
      this.currentJob.apiJob.output.forEach((output) => {
        axios.get(this.currentJob.apiJob.output[0].uri).then((response) => {
          let data = response.data;
          let input = JobManager.getInputByOutputSource(output, this.currentJob);
          data.filename = input[0].filename;
          this.results.push(data);
          this.validateloaded = true;
        });
      })
    });
  },
  methods: {
    isValidationSuccessful(result) {
      return testIsTrueish(result?.profile?.compliant);
    },
    getMainText(result) {
      if (this.isValidationSuccessful(result)) {
        return this.translate(
            'The document <strong>%filename%</strong> conforms to the %profile% standard.',
            {
              '%profile%': result?.profile?.name,
              '%filename%': result?.filename,
            }
        );
      } else {
        return translate(
            'The validation for file <strong>%filename%</strong> against %profile% was not successful, your file broke the following rules:',
            {
              '%filename%': result?.filename,
              '%profile%': result?.profile?.name,
            }
        );
      }
    },
    cleanupErrors(result) {
      if (testIsUndefined(result)) {
        return null;
      }
      //Remove duplicate errors
      //https://dev.to/marinamosti/removing-duplicates-in-an-array-of-objects-in-js-with-sets-3fep
      return Array.from(new Set(result.errors.map((error) => error.rule))).map((rule) => {
        return result.errors.find((error) => error.rule === rule);
      });
    },
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.text-output {
  white-space: pre-line;
}

.gallery-1 {
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.placeholder {
  margin: 0 auto;
  width: 100%;
  min-height: 100%;
  max-width: 1400px;
  background-color: #eee;
  border-radius: 9px;
  overflow: hidden;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 1468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 2800px 104px;
  height: 100%;
  position: relative;
}

.gallery-1 {
  display: flex;
  gap: 20px;

  img {
    object-fit: contain;
    object-position: top;
    height: 100%;
    width: 100%;
    padding-bottom: 20px;
  }
}

.image {
  object-fit: contain;
  object-position: top;
  display: flex;
  justify-content: center;
}

.loading .image,
.loading h4,
.loading .description {
  background-color: #383838;
  background: linear-gradient(
          100deg,
          rgba(255, 255, 255, 0) 40%,
          rgba(255, 255, 255, .1) 50%,
          rgba(255, 255, 255, 0) 60%
  ) #383838;
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1s loading ease-in-out infinite;


}

@keyframes loading {
  to {
    background-position-x: -20%;
  }
}
</style>
